import { observable, action, computed } from "mobx";
import {post} from "../services/ajax.service";

class DispensingStore {
  @observable total_spend = 0;
  @observable total_dispensing_fees = [];
  @observable total_claims = 0;
  @observable net_performance = 0;
  @observable net_performance_percentage = 0;
  @observable average_brand_discount = 0;
  @observable average_generic_discount = 0;
  @observable performance_table = [];
  @observable dispensingGuarantee = {}
  @observable DispensingDrugs=[]
  @observable DispensingPharmacies=[]
  @observable net_performance_dollar_value_r=0;
  @observable url ="/api/v1/performaneactions/dispensing";
  

  @computed get net_performance_value() {
    return (
      (parseInt(this.total_spend) / 100) *
      parseInt(this.net_performance_percentage)
    );
  }

  @computed get dispensing_performance () {
    let percentage = 0
    for(let i of this.performance_table){
      if(i.GUARANTEED_DISPENSING_AMOUNT > 0){
      percentage = percentage + ((i.GUARANTEED_DISPENSING_AMOUNT * i.TOTAL_CLAIMS - i.TOTAL_CLAIMS*this.returnDispensingGuarantee(i.category)) / ((i.GUARANTEED_DISPENSING_AMOUNT * i.TOTAL_CLAIMS) * 100) * 100);
    }
  }
    if(this.performance_table.length > 0){
     
    return percentage/this.performance_table.length;
    }
    else {
      return percentage;
    }
  }

  @computed get dispensing_performance_dollar_value () {
    let dollar_value = 0
    for(let i of this.performance_table){
      dollar_value = dollar_value + (i.GUARANTEED_DISPENSING_AMOUNT * i.TOTAL_CLAIMS - i.TOTAL_CLAIMS*this.returnDispensingGuarantee(i.category))
  }
    
  
      return dollar_value;
  
  }
  @action returnDispensingGuarantee = (type) => {
    if(this.dispensingGuarantee[type]){
      return this.dispensingGuarantee[type];
    }
    else {
      return 0;
    }
  }
  @action getPerformance = async data => {
    try {
      let response = await post(
        `${this.url}/getPerformance`,
        data
      );

      this.net_performance_percentage = response.data[0].PERFORMANCE_CHANGE;
    } catch (err) {
      console.log(err);
    }
  };

  @action getTotalSpend = async data => {
    try {
      let response = await post(
        `${this.url}/getTotalSpend`,
        data
      );

      this.total_spend = response.data[0].TOTAL_SPEND;
    } catch (err) {
      console.log(err);
    }
  };
  @action getTotalDispensingFees = async data => {
    try {
      this.total_dispensing_fees =[];
      let response = await post(
        `${this.url}/get_Total_Dispensing_Fees`,
        data
      );

      this.total_dispensing_fees = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getTotalClaims = async data => {
    try {
      let response = await post(
        `${this.url}/getTotalClaims`,
        data
      );

      this.total_claims = response.data[0].TOTAL_CLAIMS;
    } catch (err) {
      console.log(err);
    }
  };

  @action getGenericDiscount = async data => {
    try {
      let response = await post(
        `${this.url}/getGenericDiscount`,
        data
      );

      this.average_generic_discount = response.data[0].AVERAGE_GENERIC_DISCOUNT;
    } catch (err) {
      console.log(err);
    }
  };

  @action getBrandedDiscount = async data => {
    try {
      let response = await post(
        `${this.url}/getBrandedDiscount`,
        data
      );

      this.average_brand_discount = response.data[0].AVERAGE_BRANDED_DISCOUNT;
    } catch (err) {
      console.log(err);
    }
  };

  @action getPerformanceTable = async data => {
    try {
      let response = await post(
        `${this.url}/getPerformanceTable`,
        data
      );

      if(data.performance_review == "reconciliation"){
        this.net_performance_dollar_value_r=response.data.net_performance;
        this.performance_table = response.data.data;
        return;
      }

      this.performance_table = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getDispensingGuarantee = async data => {
    try {
      let response = await post(
        `${this.url}/getDispensingGuarantee`,
        data
      );

      this.dispensingGuarantee = response.data[0] ? this.dispensingGuarantee = response.data[0] : {};
    } catch (err) {
      console.log(err);
    }
  };


  @action getDispensingDrugs = async data => {
    this.DispensingDrugs = [];
    try {
      let response = await post(
        `${this.url}/getDispensingDrugs`,
        data
      );

      this.DispensingDrugs = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getDispensingPharmacies = async data => {
    this.DispensingPharmacies = [];
    try {
      let response = await post(
        `${this.url}/getDispensingPharamcies`,
        data
      );

      this.DispensingPharmacies = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  
}

export default DispensingStore;
